/** Match backend timeline normalization (spaces → underscores, lower case). */
function normalizeTimelineEventKey(name: unknown): string {
  return String(name ?? '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_');
}

/**
 * Backend-driven rejection: audit must contain `request_rejected` (Firestore does not store a `rejected` boolean).
 */
export function requestDocIndicatesRejected(r: {
  audit?: { last_updated_status?: Array<{ event?: string }> };
}): boolean {
  const events = r.audit?.last_updated_status ?? [];
  return events.some(e => normalizeTimelineEventKey(e.event) === 'request_rejected');
}

/**
 * User cancellation: audit must contain `request_cancelled_by_user` (no `cancelled_by_user` boolean in Firestore).
 */
export function requestDocIndicatesUserCancelled(r: {
  audit?: { last_updated_status?: Array<{ event?: string }> };
}): boolean {
  const events = r.audit?.last_updated_status ?? [];
  return events.some(e => normalizeTimelineEventKey(e.event) === 'request_cancelled_by_user');
}

/** Final workflow step present in audit (`access_provisioning_completed`). */
export function requestDocIndicatesWorkflowComplete(r: {
  audit?: { last_updated_status?: Array<{ event?: string }> };
}): boolean {
  const events = r.audit?.last_updated_status ?? [];
  return events.some(e => normalizeTimelineEventKey(e.event) === 'access_provisioning_completed');
}

export function effectiveRequestStatus(r: {
  status: 'open' | 'in-progress' | 'closed';
  audit?: { last_updated_status?: Array<{ event?: string }> };
}): 'open' | 'in-progress' | 'closed' {
  if (
    requestDocIndicatesRejected(r) ||
    requestDocIndicatesUserCancelled(r) ||
    requestDocIndicatesWorkflowComplete(r)
  ) {
    return 'closed';
  }
  return r.status;
}
